import { gql, useQuery } from "@apollo/client";

export const GET_ORGANISATION_WITH_STRIPE_ACCOUNT_DETAILS = gql`
  query getOrganisationWithStripeAccountDetails($shortName: String!) {
    organisationByShortName(shortName: $shortName) {
      id
      stripeAccountDetails {
        chargesEnabled
      }
    }
  }
`;

export const isPaymentRequired = paymentOptions => !!paymentOptions && (paymentOptions.defaultDivisionPrice > 0 || !!paymentOptions.divisions?.some(division => division.price > 0) || !!paymentOptions.extras?.some(extra => extra.price > 0));

export const useCanAcceptPayments = (paymentOptions, shortName) => {
    const requiresPayment = isPaymentRequired(paymentOptions);

    const { data } = useQuery(GET_ORGANISATION_WITH_STRIPE_ACCOUNT_DETAILS, { skip: !requiresPayment, variables: { shortName }, fetchPolicy: "cache-and-network", nextFetchPolicy: "cache-first" }),
        chargesEnabled = data?.organisationByShortName.stripeAccountDetails.chargesEnabled;

    return typeof chargesEnabled === "undefined" || chargesEnabled;
};
